import $ from 'jquery';

const slideUpAllExcept = x => {
    $('.itemBody').each((i, e) => {
        if(x !== i) {
            $(e).parent().find('.itemTop').find('svg').removeClass('aOpen');
            $(e).slideUp('fast');
        }
    });
};

const execAccordion = () => {
    // Accordion main function

    // Add click handlers to all accordion items
    $('.itemContainer').each((i, e) => {

        $(e).find('#itemToggler').click(() => {
            // Slide up all except the clicked one
            slideUpAllExcept(i);
            
            // Slide toggle this
            $(e).find('.itemBody').slideToggle('fast');
            $(e).find('.itemTop').find('svg').toggleClass('aOpen');
        });
    });

    // Open the first accordion on the page
    $($('.itemContainer')[0]).find('#itemToggler').trigger( "click" );
};

// Check if there is an accordion on the page
if($('.itemContainer').length) {
    // Run main function
    execAccordion();
}